export { PotencySlider } from './potency-slider';
